export const MODAL_TITLE = 'Add Lease Document';
export const ADD_LEASE_BTN = 'Add Lease';
